import { cn } from '@/lib/utils';
import { TransactionTypeEnum } from '@/enums';

type TProps = {
	amount: number;
	type: TransactionTypeEnum;
};

export const AmountDisplay = ({ amount, type }: TProps) => {
	const isIncome = type === TransactionTypeEnum.INCOME;
	return (
		<span className={cn('font-bold tabular-nums block text-sm', isIncome ? 'text-emerald-500' : 'text-red-500')}>
			{isIncome ? '+' : '-'}
			{amount.toLocaleString('fr-FR')} 🪙
		</span>
	);
};
